var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M14.5 0.5L0.5 6.5L5.5 9.5M14.5 0.5L8.5 14.5L5.5 9.5M14.5 0.5L5.5 9.5","stroke-linecap":"square","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }